import { authHeader, history } from "../_helpers";
import config from "../config";
export const storeProceduresService = {
  get_crime_data_shirshak,
  get_crime_data_laghu_shirshak,
  get_crime_data_modas,
  get_crime_data_kayda,
  get_crime_data_shirshak_haddit_gunhe,
  get_crime_data_laghu_shirshak_haddit_gunhe,
  get_crime_data_modas_haddit_gunhe,
  get_crime_data_kayda_haddit_gunhe,
  get_crime_data_shirshak_usr,
  get_crime_data_laghu_shirshak_usr,
  get_crime_data_kayda_usr,
  get_crime_data_modas_usr,
};
const baseUrl = config.apiGateway.baseUrl;
function get_crime_data_shirshak(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/get_crime_data_shirshak/`, requestOptions);
}

function get_crime_data_laghu_shirshak(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/get_crime_data_laghu_shirshak/`,
    requestOptions
  );
}
function get_crime_data_modas(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/get_crime_data_modas/`, requestOptions);
}
function get_crime_data_kayda(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/get_crime_data_kayda/`, requestOptions);
}
function get_crime_data_shirshak_haddit_gunhe(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/get_crime_data_shirshak_haddit_gunhe/`,
    requestOptions
  );
}
function get_crime_data_laghu_shirshak_haddit_gunhe(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/get_crime_data_laghu_shirshak_haddit_gunhe/`,
    requestOptions
  );
}
function get_crime_data_modas_haddit_gunhe(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/get_crime_data_modas_haddit_gunhe/`,
    requestOptions
  );
}
function get_crime_data_kayda_haddit_gunhe(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/get_crime_data_kayda_haddit_gunhe/`,
    requestOptions
  );
}
function get_crime_data_shirshak_usr(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/get_crime_data_shirshak_usr/`,
    requestOptions
  );
}
function get_crime_data_laghu_shirshak_usr(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/get_crime_data_laghu_shirshak_usr/`,
    requestOptions
  );
}
function get_crime_data_kayda_usr(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/get_crime_data_kayda_usr/`, requestOptions);
}
function get_crime_data_modas_usr(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/get_crime_data_modas_usr/`, requestOptions);
}
